import { render, staticRenderFns } from "./Empresa-tab-dados-principais.vue?vue&type=template&id=4c16f2d1&"
import script from "./Empresa-tab-dados-principais.vue?vue&type=script&lang=js&"
export * from "./Empresa-tab-dados-principais.vue?vue&type=script&lang=js&"
import style0 from "./Empresa-tab-dados-principais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports